import React from "react";
import { Link } from "react-router-dom"
import { useNavigate, useParams } from "react-router-dom";
import { useState, useEffect } from 'react';
import swal from 'sweetalert';
import APIConfig from "../../../api/APIConfig";
import classes from "./styles.module.css"; 
import {
    Box,
    Center,
    Heading,
    Button,
    Text,
    VStack,
    HStack,
} from '@chakra-ui/react';

import ReactLoading from "react-loading";

function DetailProposal() {
    const navigate = useNavigate();
    const { id } = useParams();
    const [isPublished, setIsPublished] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [namaProposal, setNamaProposal] = useState("-");
    const [penyelenggara, setPenyelenggara] = useState("-");
    const [tanggalMulai, setTanggalMulai] = useState();
    const [tanggalSelesai, setTanggalSelesai] = useState();
    const [lokasi, setLokasi] = useState("-");
    const [deskripsi, setDeskripsi] = useState("-");
    const [posisi, setPosisi] = useState("-");
    const [jobdesc, setJobdesc] = useState("");
    const [kriteriaPeserta, setKriteriaPeserta] = useState("-");
    const [kemampuanWajib, setKemampuanWajib] = useState("-");
    const [infoTambahan, setInfoTambahan] = useState("-");
    const [kuota, setKuota] = useState();
    const [keteranganRevisi, setKeteranganRevisi] = useState("-");
    const [alasanPenolakan, setAlasanPenolakan] = useState("-");
    const [isRevised, setRevisedStatus] = useState(false)
    const [isRejected, setRejected] = useState(false);
    const [validation, setValidation] = useState({});
    const [spinner, setSpinner] = useState(false);  
    useEffect(() => {
        getProposalById();
        
    }, []);

    const getProposalById = async() => {
        setSpinner(true);
        const response = await APIConfig.get(`/v1/proposal/${id}`);
        const data = await response.data
        console.log(data)
        setNamaProposal(data.namaProposal)
        setPosisi(data.namaPosisi)
        setDeskripsi(data.deskripsiAktivitas)
        setJobdesc(data.deskripsiPekerjaan)
        setLokasi(data.lokasi)
        setInfoTambahan(data.infoTambahan)
        setKemampuanWajib(data.kemampuanWajib)
        setKriteriaPeserta(data.kriteriaPeserta)
        setKeteranganRevisi(data.keteranganRevisi)
        setAlasanPenolakan(data.alasanPenolakan)
        setTanggalMulai(data.tanggalMulai)
        setTanggalSelesai(data.tanggalSelesai)
        setPenyelenggara(data.mitra.namaBrand)
        setKuota(data.kuota)
        
        if(data.statusProposal === 'Dipublikasikan') {
            console.log("dipublikasikan")
            setIsPublished(true);
        } 
        
        if (data.statusProposal === 'Butuh Revisi') {
            console.log("butuh revisi")
            setRevisedStatus(true);
        } 
        
        if(data.statusProposal === 'Terkumpul') {
            console.log("terkumpul")
            setIsSubmitted(true);
        } 

        if(data.statusProposal === 'Ditolak') {
            setRejected(true);
        } 

        setSpinner(false);
    };

    const terimaProposal = async (e) => {
        e.preventDefault();
        swal("Apakah anda yakin untuk menerima proposal ini?", {
        buttons: {
            yes: {
            text: "Ya",
            value: "yes"
            },
            no: {
            text: "Tidak",
            value: "no"
            }
        }
         }).then((value) => {
        if (value === "yes") {
            APIConfig.put(`v1/proposal/status/${id}`, {
                statusProposal: "Dipublikasikan",
            })
            .then(() => {
                console.log("berhasil menyetujui") 
                swal({
                    title: "Berhasil disetujui",
                    icon: "success",
                    button: "OK",
                }); 
                navigate("/admin/verifikasi/proposal");
            })
            .catch((error) => {
                console.log(error);
                setValidation(error.response.data);
            })
        }
        return false;
        });
    };

    if (spinner) {
        return (
            <Center py={12}>
                <VStack align='stretch' fontFamily={'Inter'} pb={20}>
                <div className="section">
                    <div className="article">
                        <ReactLoading type="spin" color="#6554C0" />
                    </div>
                </div>
                </VStack>
            </Center>
              
        )
    }

    return (
        <Center py={6}>
        <VStack align='stretch' justifyItems='left' fontFamily={'Inter'} pb={20}>
            <Text
                color={'gray.700'}
                fontWeight={600}
                fontSize={'2xl'}>
                Detail Proposal
            </Text>
            <HStack color={'gray.500'} pb={10}>
                <Link to="/admin/verifikasi/proposal"> Verifikasi Proposal </Link>
                <p> / </p>
                <Link to="/admin/detail/proposal"> Detail Proposal </Link>
            </HStack>
            { isSubmitted && 
            <HStack pr={6} align="end" pb={10} justifyContent='right' direction='row' spacing={2} alignItems='center'>
                <Button
                    onClick={() => navigate(`/admin/verifikasi/proposal/tolak/${id}`)}
                    fontSize={'small'}
                    type='submit'
                    color="white"
                    p={4} 
                    rounded={'xl'} 
                    backgroundColor={'red.700'} 
                    variant='outline'>
                    Tolak
                </Button>
                <Button
                    onClick={terimaProposal}
                    fontSize={'small'}
                    color="white"
                    type='submit'
                    p={4}
                    backgroundColor={'green.700'} 
                    rounded={'xl'}
                    variant='solid'>
                    Terima
                </Button>
                <Button 
                    onClick={() => navigate(`/admin/verifikasi/proposal/revisi/${id}`)}
                    fontSize={'small'}
                    color="white"
                    type='submit'
                    p={4}
                    backgroundColor={'yellow.500'} 
                    rounded={'xl'}
                    variant='solid'>
                    Revisi
                </Button> 
            </HStack>
            }

            { isRevised && 
            <HStack pr={6} align="end" pb={10} justifyContent='right' direction='row' spacing={2} alignItems='center'>
                <Button
                    onClick={() => navigate(`/admin/verifikasi/proposal/tolak/${id}`)}
                    fontSize={'small'}
                    type='submit'
                    color="white"
                    p={4} 
                    rounded={'xl'} 
                    backgroundColor={'red.700'} 
                    variant='outline'>
                    Tolak
                </Button>
                <Button
                    onClick={terimaProposal}
                    fontSize={'small'}
                    color="white"
                    type='submit'
                    p={4}
                    backgroundColor={'green.700'} 
                    rounded={'xl'}
                    variant='solid'>
                    Terima
                </Button>
                <Button 
                    onClick={() => navigate(`/admin/verifikasi/proposal/revisi/${id}`)}
                    fontSize={'small'}
                    color="white"
                    type='submit'
                    p={4}
                    backgroundColor={'yellow.500'} 
                    rounded={'xl'}
                    variant='solid'>
                    Revisi
                </Button> 
            </HStack>
            }

            { isPublished &&
            <HStack pr={6} align="end" pb={10} justifyContent='right' direction='row' spacing={2} alignItems='center'>
                <Button 
                    onClick={() => navigate(`/admin/verifikasi/proposal/revisi/${id}`)}
                    fontSize={'small'}
                    color="white"
                    type='submit'
                    p={4}
                    backgroundColor={'yellow.500'} 
                    rounded={'xl'}
                    variant='solid'>
                    Revisi
                </Button>
            </HStack>
            }

            <Box
                m='10px'
                w='4xl'
                h="100%"
                border='1px'
                borderColor='gray.200'
                justifyContent='left'
                rounded={'2xl'}
                p={6}
                overflow={'hidden'}>
                <VStack 
                spacing={6}
                align='stretch'
                p={3}
                >
                    <Heading
                        mb={6}
                        mt={3}
                        fontSize={'xl'}
                        fontFamily={'Inter'}>
                        Detail Aktivitas
                    </Heading>
                    <VStack align='stretch' spacing={2}>
                        <h3 className={classes.h} >Nama Aktivitas</h3>
                        <p className={classes.p}>{namaProposal}</p>
                    </VStack>
                    <VStack align='stretch' spacing={2}>
                        <h3 className={classes.h} >Mitra Penyelenggara</h3>
                        <p className={classes.p}>{penyelenggara}</p>
                    </VStack>
                    <VStack align='stretch' spacing={2}>
                        <h3 className={classes.h} >Tanggal Mulai</h3>
                        <p className={classes.p}>{tanggalMulai}</p>
                    </VStack>
                    <VStack align='stretch' spacing={2}>
                        <h3 className={classes.h} >Tanggal Selesai</h3>
                        <p className={classes.p}>{tanggalSelesai}</p>
                    </VStack>
                    <VStack align='stretch' spacing={2}>
                        <h3 className={classes.h} >Lokasi</h3>
                        <p className={classes.p}>{lokasi}</p>
                    </VStack>
                    <VStack align='stretch' spacing={2}>
                        <h3 className={classes.h} >Kuota</h3>
                        <p className={classes.p}>{kuota}</p>
                    </VStack>
                    <VStack align='stretch' spacing={2}>
                        <h3 className={classes.h} >Deskripsi</h3>
                        <p className={classes.p}>{deskripsi}</p>
                    </VStack>

                    <Heading
                        pt={6}
                        fontSize={'xl'}
                        fontFamily={'Inter'}>
                        Detail Lowongan
                    </Heading>
                    <VStack align='stretch' spacing={2}>
                        <h3 className={classes.h} >Nama Posisi</h3>
                        <p className={classes.p}>{posisi}</p>
                    </VStack>
                    <VStack align='stretch' spacing={2}>
                        <h3 className={classes.h} >Deskripsi Pekerjaan</h3>
                        <p className={classes.p}>{jobdesc}</p>
                    </VStack>
                    <VStack align='stretch' spacing={2}>
                        <h3 className={classes.h} >Kriteria Peserta</h3>
                        <p className={classes.p}>{kriteriaPeserta}</p>
                    </VStack>
                    <VStack align='stretch' spacing={2}>
                        <h3 className={classes.h} >Kemampuan Wajib</h3>
                        <p className={classes.p}>{kemampuanWajib}</p>
                    </VStack>
                    <VStack align='stretch' spacing={2}>
                        <h3 className={classes.h} >Informasi Tambahan</h3>
                        <p className={classes.p}>{infoTambahan}</p>
                    </VStack>
                    { isRevised &&
                    <VStack align='stretch' spacing={2}>
                    <h3 className={classes.h} >Keterangan Revisi</h3>
                    <p className={classes.p}>{keteranganRevisi}</p>
                    </VStack>}
                    { isRejected &&
                    <VStack align='stretch' spacing={2}>
                    <h3 className={classes.h} >Alasan Penolakan</h3>
                    <p className={classes.p}>{alasanPenolakan}</p>
                    </VStack>}
                </VStack>
            </Box>
        </VStack>
        </Center>
    );
}

export default DetailProposal;